import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { imageApi } from "../api/image";
import profileApi from "../api/profile";
import { projectApi } from "../api/project";
import { resultApi } from "../api/result";
import { userApi } from "../api/user";
import { tileSelectionApi } from "../api/tileSelection";
import tenantApi from "../api/tenant";
import inviteApi from "../api/userInvite";
import { checkoutApi } from "../api/checkout";
import { favoriteApi } from "../api/favorite";
import authReducer from "./authSlice";
import accountStatusReducer from "./accountStatusSlice";
import imageReducer from "./imageSlice";
import modalReducer from "./modalSlice";
import profileReducer from "./profileSlice";
import projectReducer from "./projectSlice";
import { resultCompareApi } from '../api/resultCompare';
import resultReducer from './resultSlice';
import imageQueueReducer from "./imageQueueSlice";
import tileSelectionReducer from "./tileSelectionSlice";

const appReducer = combineReducers({
  // Add the generated reducer as a specific top-level slice
  [userApi.reducerPath]: userApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
  [imageApi.reducerPath]: imageApi.reducer,
  [resultApi.reducerPath]: resultApi.reducer,
  [resultCompareApi.reducerPath]: resultCompareApi.reducer,
  [tileSelectionApi.reducerPath]: tileSelectionApi.reducer,
  [tenantApi.reducerPath]: tenantApi.reducer,
  [inviteApi.reducerPath]: inviteApi.reducer,
  [checkoutApi.reducerPath]: checkoutApi.reducer,
  [favoriteApi.reducerPath]: favoriteApi.reducer,
  modal: modalReducer,
  image: imageReducer,
  project: projectReducer,
  auth: authReducer,
  accountStatus: accountStatusReducer,
  profile: profileReducer,
  result: resultReducer,
  imageQueue: imageQueueReducer,
  tileSelection: tileSelectionReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'auth/clearAll') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  // Adding the middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userApi.middleware,
      profileApi.middleware,
      projectApi.middleware,
      imageApi.middleware,
      resultApi.middleware,
      resultCompareApi.middleware,
      tileSelectionApi.middleware,
      tenantApi.middleware,
      inviteApi.middleware,
      checkoutApi.middleware,
      favoriteApi.middleware),
  // Enabling the Redux DevTools Extension is a good default, but you can customize it to your needs
  devTools: process.env.NODE_ENV !== "production",
});

// Export the type of the root state
export type RootState = ReturnType<typeof store.getState>;
// Export the store's dispatch function type
export type AppDispatch = typeof store.dispatch;
